var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.actions.length
        ? _c("TranscriptSummaryCard", { attrs: { title: "Ações geradas" } }, [
            _c(
              "div",
              { staticClass: "d-flex flex-column az-gap-small" },
              _vm._l(_vm.actions, function(action, i) {
                return _c("TranscriptSummaryItem", {
                  key: i,
                  attrs: {
                    icon: "check-circle",
                    "icon-color": "success",
                    text: _vm.actionLabel(action)
                  },
                  scopedSlots: _vm._u(
                    [
                      _vm.actionTag(action)
                        ? {
                            key: "right",
                            fn: function() {
                              return [
                                _c(
                                  "v-chip",
                                  {
                                    attrs: {
                                      "x-small": "",
                                      color: "#E8EAF1",
                                      "text-color": "#5B5B5B"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.actionTag(action)) + " "
                                    )
                                  ]
                                )
                              ]
                            },
                            proxy: true
                          }
                        : null
                    ],
                    null,
                    true
                  )
                })
              }),
              1
            )
          ])
        : _c(
            "TranscriptStateFeedback",
            _vm._b({}, "TranscriptStateFeedback", _vm.acoesFeedback, false)
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }